import { render, staticRenderFns } from "./cassation-send-confirmation-modal.vue?vue&type=template&id=47f9648a&scoped=true&"
import script from "./cassation-send-confirmation-modal.vue?vue&type=script&lang=js&"
export * from "./cassation-send-confirmation-modal.vue?vue&type=script&lang=js&"
import style0 from "./cassation-send-confirmation-modal.vue?vue&type=style&index=0&id=47f9648a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f9648a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCheckbox,VSimpleTable})
